import { Col, Row } from "react-bootstrap";
import MaterialIcon, {
  MtIcon,
} from "../../../../shared/oversight-core/ui-elements/material-icon/material-icon";
import styles from "./include-system-card.module.scss";

interface IProps {
  icon: MtIcon;
  text: string;
  onClick: () => void;
  textWidth?: string;
}

const IncludeSystemCard = (props: IProps) => {
  const { icon, text, onClick, textWidth = "180px" } = props;

  return (
    <div
      className={`${styles.includeSolarEnergy} cursor-pointer h-100 mx-0`}
      onClick={onClick}
    >
      <Row className="row-cols-auto align-items-center justify-content-center g-4 px-4">
        <Col>
          <MaterialIcon
            icon={icon}
            color="var(--color-system-icon)"
            size={20}
            fill
          />
        </Col>
        <Col
          className="title-4 font-weight-500 font-size-13 px-0"
          style={{ width: `${textWidth}` }}
        >
          {text}
        </Col>
        <Col className="ps-0">
          <MaterialIcon
            icon="add"
            color="var(--color-solar-system-type-title)"
            size={20}
            fill
          />
        </Col>
      </Row>
    </div>
  );
};

export default IncludeSystemCard;
